import type { ButtonHTMLAttributes, ReactNode } from "react";

export type ButtonVariant = "primary" | "secondary" | "ghost";

export function Button({
  variant = "primary",
  children,
  ...rest
}: ButtonHTMLAttributes<HTMLButtonElement> & { variant?: ButtonVariant }): JSX.Element {
  return (
    <button className={`btn btn--${variant}`} {...rest}>
      {children}
    </button>
  );
}

export function Card({
  title,
  description,
  children,
  footer,
}: {
  title?: string;
  description?: string;
  children?: ReactNode;
  footer?: ReactNode;
}): JSX.Element {
  return (
    <section className="card">
      {title ? <h3 className="card__title">{title}</h3> : null}
      {description ? <p className="card__desc">{description}</p> : null}
      {children}
      {footer}
    </section>
  );
}

export type StatusTone = "ok" | "warn" | "danger" | "neutral";

export function StatusIndicator({
  tone,
  label,
}: {
  tone: StatusTone;
  label: string;
}): JSX.Element {
  return (
    <span className={`status status--${tone}`} role="status">
      <span className="status__dot" aria-hidden="true" />
      {label}
    </span>
  );
}

export function Badge({ children }: { children: ReactNode }): JSX.Element {
  return <span className="badge">{children}</span>;
}
